module.exports = __webpack_public_path__ + "static/media/tell.f6851df8.svg";